import React from 'react';
import { CheckmarkStyles } from './Checkmark.styled';

type Props = {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
};

const Checkmark = ({
  height = 18,
  width = 21,
  color,
  className = '',
}: Props) => (
  <CheckmarkStyles strokeColor={color}>
    <svg
      className={'checkmark ' + className}
      width={width}
      height={height}
      viewBox={`0 0  ${width} ${height}`}
    >
      <title>Checkmark</title>
      <path fillRule="evenodd" d="M2.597 10.064l4.52 4.52L18.491 3.212" />
    </svg>
  </CheckmarkStyles>
);

export default Checkmark;
